var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.525,
    height: 25,
    viewBox: "0 0 31.525 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(399.68 599.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M-399.68-599.025h11.519v14.031l-11.519,10.969Z",
    transform: "translate(0 0)",
    fill: "#a66416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-299.36-599.025h11.519v14.031l-11.519,10.969Z",
    transform: "translate(-80.314 0)",
    fill: "#a66416"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewquote);
export default __webpack_public_path__ + "static/media/newquote.00e66b92cb5de516d0458de9d6d2c356.svg";
export { ForwardRef as ReactComponent };